import { Component, OnInit } from "@angular/core";
import { LoadingBarService } from "../loading-bar.service";

@Component({
  selector: "app-loading-bar",
  templateUrl: "./loading-bar.component.html",
  styleUrls: ["./loading-bar.component.scss"]
})
export class LoadingBarComponent implements OnInit {
  public hidden = true
  //constructor() {}
  constructor(private LoadingBarService: LoadingBarService) { }

  ngOnInit() {
    this.LoadingBarService.isVisibleSource.subscribe((isVisible: boolean) => {
      this.hidden = !isVisible
      //console.log('isVisible: ', isVisible); // => true/false
    });
}
}
